<!-- LAYOUT -->
<ng-container>
    <layout></layout>
</ng-container>
<!-- / LAYOUT -->
